export default __webpack_public_path__ + "static/media/4.d20287c6.svg";